<template>
  <fragment>
    <podcaster-dashboard v-if="isPodcaster()" />
    <broadcaster-dashboard v-else />
  </fragment>
</template>
<script>
import PodcasterDashboard from "VueApp/Home/PodcasterDashboard";
import BroadcasterDashboard from "VueApp/Home/BroadcasterDashboard";
export default {
  components: { BroadcasterDashboard, PodcasterDashboard },
};
</script>
